<template>
  <v-flex>
      <div ref="content">
      <v-card>

          <v-hover>
          <v-card-text slot-scope="{ hover }" class="caption grey--text">
              <v-layout style="min-height:40px;">
                  <loading-progress-bar :loading="loading" color="secondary"></loading-progress-bar>

                  <v-spacer></v-spacer>

                  <v-fade-transition>
                  <span v-show="(!loading && hover)" ma-0 pa-0>
                      <v-btn @click="downloadWithCSS" outline small flat round class="grey--text" ma-0 pa-0>
                          <!-- TODO Fine tune download pdf -->
                          Export as PDF
                      </v-btn>
                      <v-btn @click="downloadCSV" outline small flat round class="grey--text" ma-0 pa-0>
                          Download CSV
                      </v-btn>
                  </span>
                  </v-fade-transition>
                  <span>{{facilityName}} {{equipment_name}}</span>
              </v-layout>
          </v-card-text>
          </v-hover>
          <v-card-text v-if="type==='dygraph'">
              <dygraphs-component :df="df" ref="dygraphplot"></dygraphs-component>
          </v-card-text>
          <v-card-text v-else>
              <vue-plotly disable-responsive :data="data" :layout="layout" :options="options" ref="plotly"/>
          </v-card-text>
      </v-card>
      </div>
  </v-flex>
</template>

<script>
import VuePlotly from '@/components/VuePlotly'
import {getTimeSeries} from '@/helper'
import DygraphsComponent from './DygraphsComponent'
import LoadingProgressBar from './LoadingProgressBar'
import jsPDF from 'jspdf'
import {exportCSVFromDicts} from "@/tocsv.js"

export default {
  props: {
    title: {type: String, default: ''},
    facility_name: {type: String, default: null},
    equipment_name: {type: String, default: 'Chiller 1'},
    variableX: {type: String, default: 'CHWR_Temp'},
    variableY: {type: String, default: 'CHWS_Temp'},
    dateRange: {type: Object, default: null},
    type: {type: String, default: 'scattergl'},
    onOnly: {type:Boolean, default: false}
  },
  components: {
    LoadingProgressBar,
    DygraphsComponent,
    VuePlotly
  },
  computed: {
    layout(){
      return {
        title: this.title,
        hovermode: 'closest',
        xaxis: {
          title: this.variableX
        },
        yaxis: {
          title: this.type==='histogram'? 'Count' : this.variableY
        }
      }
    }
  },
  name: 'ScatterPlot',
  watch: {
    facility_name () {
      this.refresh()
    },
    variableX () {
      this.refresh()
    },
    variableY () {
      this.refresh()
    },
    equipment_name() {
      this.refresh()
    },
    dateRange () {
      this.refresh()
    },
    onOnly () {
      this.refresh()
    }
  },
  data: function () {
    return {
      data:[],
      options: {},
      timeout:null,
      facilityName:this.facility_name,
      df: null,
      loading: true
    }
    },
  methods: {
    downloadCSV () {
      exportCSVFromDicts(this.df)
    },
    download() {
      const doc = new jsPDF();
      const contentHtml = this.$refs.content.innerHTML;

      doc.fromHTML(contentHtml, 15, 15, {
        width: 170
      });
      doc.save("export.pdf");
    },
     async downloadWithCSS() {
       var doc = new jsPDF('', 'pt', 'a4');

       /** WITH CSS */
       let img = null
       if(this.type==='dygraph'){
         img = this.$refs.dygraphplot.toImage()
         doc.addImage(img, 'JPEG', 0, 0,
           1.0*595.28,
           1.0*595.28/this.$refs.dygraphplot.$refs.graphdiv.clientWidth*this.$refs.dygraphplot.$refs.graphdiv.clientHeight)
       } else {
         img =  await this.$refs.plotly.toImage()
         doc.addImage(img, 'JPEG', 0, 0,
           1.0*595.28,
           1.0*592.28/this.$refs.plotly.$refs.container.clientWidth*this.$refs.plotly.$refs.container.clientHeight
         )
       }

        doc.save("export.pdf")

     },
      debounce(callback, wait) {
          clearTimeout(this.timeout);
          this.timeout= setTimeout(() => callback(), wait);
      },
      refresh(){
          this.debounce(this.doRefresh,200);
      },
    async doRefresh() {
        if(this.facility_name){
            this.facilityName=this.facility_name;
        }
      this.loading=true
      if (!!this.variableX & !!this.variableY & !!this.equipment_name & !!this.facilityName){
        let df = await getTimeSeries(
          [this.variableX, this.variableY],
          this.equipment_name,
          this.facilityName,
          this.dateRange,
          null,
          this.onOnly
        )
        this.df = df
        this.data = [
          {x: df[this.variableX], y: df[this.variableY], type: this.type, mode: 'markers'}
        ]
      }
      this.loading=false
    }
  },
   mounted () {
    if (!this.facilityName) {
      this.facilityName = this.$store.state.pointsListStore.pointsList.facility_name
    }
    this.refresh()
  }
}

</script>

<style scoped>

</style>
